import { API_BASE } from './apiBase';

/**
 * The 1200×630 card an unfurler (WhatsApp, Messenger, iMessage, …) shows for an event. The API
 * draws it on first ask and caches it; server.js links it as og:image. Pages hand it to
 * ShareSheet as `cardUrl` so the sheet can warm it before the link is pasted anywhere.
 */
export const eventCardUrl = (inviteCode) => (inviteCode ? `${API_BASE}/og/event/${encodeURIComponent(inviteCode)}.jpg` : undefined);
